<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">异卡发放审核</li>
      <el-button
        type="primary"
        :icon="Upload"
        link
        @click="onExport"
        v-if="$judge_auth('818')"
        size="large"
        >导出
      </el-button>
    </ul>
    <ul class="c-list-search">
      <c_statusradiogroup
        v-model="state.params.check_status"
        arrName="diffbank_check_status"
        @change="onLoad"
      ></c_statusradiogroup>
      <el-input
        v-model="state.params.keywords"
        style="width: 200px"
        placeholder="姓名、证件号"
        clearable
        @clear="
          delete state.params.keywords;
          onLoad();
        "
        @paste.enter="$onKeywordsPaste($event, state.params)"
      ></el-input>
      <el-date-picker
        v-model="state.dates"
        type="daterange"
        range-separator="至"
        start-placeholder="申请日期"
        end-placeholder="申请日期"
        value-format="YYYY-MM-DD"
        @change="
          (value) => {
            if (value) state.params.create_time = value[0] + ' - ' + value[1];
          }
        "
        @clear="
          delete state.dates;
          delete state.params.create_time;
        "
      />
      <el-select
        v-model="state.params.customer_id"
        placeholder="所属客户"
        style="width: 300px"
      >
        <el-option
          v-for="item in state.customerData"
          :key="item.id"
          :label="item.alias + '(' + item.name + ')'"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadCustomer()"> 刷新 </el-button>
        </template>
      </el-select>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          label="状态"
          prop="check_status"
          :formatter="$tab_TextFormat"
        >
          <template #default="{ row }">
            <c_status
              arr-name="diffbank_check_status"
              :value="row.check_status"
            ></c_status>
          </template>
        </el-table-column>
        <el-table-column
          label="姓名"
          prop="name"
          :formatter="$tab_TextFormat"
        />
        <el-table-column prop="idcard" label="证件号" width="180">
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="证件号"
              @click.stop="$onCopy(row.idcard)"
            >
              {{ row.idcard }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          label="扣缴义务人"
          prop="withholding_agent_name"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="所属客户"
          prop="customer_name"
          :formatter="$tab_TextFormat"
        />
        <el-table-column label="所属客服">
          <template #default="{ row }">
            <c_tabgroup
              :value1="row.belonger_name || '-'"
              :value2="row.belonger_department_name"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="申请时间"
          prop="create_time"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="异卡户名"
          prop="bank_account_name"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="异卡开户行"
          prop="opening_bank"
          :formatter="$tab_TextFormat"
        />
        <el-table-column label="异卡账户">
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="异卡账户"
              @click.stop="$onCopy(row.bank_account)"
            >
              {{ row.bank_account }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          label="申请说明"
          prop="reason"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="操作"
          width="120"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Select"
              v-if="row.check_status === 0 && $judge_auth('137')"
              @click="
                $store.commit('openMenu', {
                  path: 'DiffBankDetail',
                  title: '异卡发放审核',
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
            >
              审核
            </el-button>
            <el-button
              link
              icon="Search"
              v-else
              @click="
                $store.commit('openMenu', {
                  path: 'DiffBankDetail',
                  title: '异卡发放详情',
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
            >
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { diffbank_list, diffbank_export } from "@/http/diffbank";
import { data_customer_select } from "@/http/data";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_value: "desc",
  };
}
export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoadCustomer();
      onLoad();
    });

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    const onLoad = () => {
      delete state.tableData;

      diffbank_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    const onDateChange = (value) => {
      if (value) state.params.create_time = value[0] + " - " + value[1];
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      delete state.date;
      Object.assign(state, new InitFormData());
      onLoad();
    };

    const onExport = () => {
      let params = JSON.parse(JSON.stringify(state.params));
      params.limit = 0;
      diffbank_export(params)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1],
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8",
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onDateChange,
      onExport,
    };
  },
};
</script>
<style lang="less">
.bank-received-index-tab-pop {
  .el-descriptions__header {
    margin-bottom: 0 !important;
  }
}
</style>
